import React from "react";

import FAQ from "../pages/FAQHome";
import { Helmet } from "react-helmet-async";

export default function HomeFaq({ faq1, faq2, subtitle }) {
  const handleRedirect = () => {
    window.location.href = "https://app.waggex.com/signup";
  };

  return (
    <>
      <div className="bg-white py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Common Heading */}
          <div className="text-center mb-4">
            <h2
              className="
    relative inline-block
    text-[#10324F]
    text-xl sm:text-3xl
    font-roboto font-bold uppercase"
            >
              Frequently Asked Questions
            </h2>
            {subtitle && (
              <p className="text-center text-[#10324F] text-lg mt-4">
                {subtitle}
              </p>
            )}
          </div>

          {/* Two Column FAQ */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Left FAQs */}
            <FAQ items={faq1} defaultOpenIndex={null} />

            {/* Right FAQs */}
            <FAQ items={faq2} defaultOpenIndex={null} />
          </div>
        </div>
      </div>
    </>
  );
}
